import { ProductCardType } from '@petz/ds-card/dist/ProductCard/types'

async function fetchProducts(...urls: string[]): Promise<ProductCardType[]> {
  const responses = await Promise.all(
    urls.map((url) =>
      fetch(url).then(
        (response) => response,
        (error) => {
          console.warn(`Failed to fetch ${url}: ${error.message}`)
          return null
        }
      )
    )
  )

  const validResponses = responses.filter((response) => response !== null)
  const data = await Promise.all(validResponses.map((response) => response.json()))

  const allProducts = data.map((d) => d.result.products)
  const maxLength = Math.max(Math.max(...allProducts.map((products) => products.length)), 12)
  const mixedProducts = []

  for (let i = 0; i < maxLength; i++) {
    for (const products of allProducts) {
      if (i < products.length) {
        mixedProducts.push(products[i])
      }
    }
  }

  return mixedProducts
}

export { fetchProducts }
